/**
 * Allow-list device gate for the QR co-ordering PWA.
 *
 * The page is reserved for smartphones. Tablets and desktops see the
 * UnsupportedDevicePage instead. The detection is User-Agent based with a
 * touch-points fallback for iPadOS 13+ which masquerades as macOS.
 *
 * Strategy:
 *   - allow iPhone, iPod, Windows Phone, Android phones (UA contains "Mobile")
 *   - block iPad, Android tablets (Android without "Mobile"), Kindle, generic
 *     "Tablet" UAs, and anything else (desktop browsers).
 */
export const isSmartphoneOnly = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return true; // SSR-safe default; the runtime check kicks in once mounted
  }

  const ua = navigator.userAgent;

  // ---- explicit allow list ---------------------------------------------------
  if (/iPhone|iPod/i.test(ua)) return true;
  if (/Windows Phone/i.test(ua)) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;

  // ---- explicit block list ---------------------------------------------------
  if (/iPad/i.test(ua)) return false;
  if (/Android/i.test(ua)) return false; // Android without "Mobile" → tablet
  if (/Tablet|PlayBook|Silk|Kindle/i.test(ua)) return false;

  // iPadOS 13+ masquerades as Macintosh; the giveaway is touch support.
  if (/Macintosh/i.test(ua) && (navigator.maxTouchPoints ?? 0) > 1) return false;

  // Anything else (desktop, robots, weird OS) → block.
  return false;
};
